import {USDCIcon} from "../../icons/assets/USDC";
import {USDTIcon} from "../../icons/assets/USDT";
import {WSTETHIcon} from "../../icons/assets/WSTETH";
import {CUSDOIcon} from "../../icons/assets/CUSDO";
// import {IvIUSDIcon} from "../../icons/assets/IvIUSD";
// import {DeUSDIcon} from "../../icons/assets/DeUSD";
import {RUSDIcon} from "../../icons/assets/RUSD";
import {USD0Icon} from "../../icons/assets/USD0";
import {WBTCIcon} from "../../icons/assets/WBTC";
import {WETHIcon} from "../../icons/assets/WETH";
import {WeETHIcon} from "../../icons/assets/WeETH";
// import {PxETHIcon} from "../../icons/assets/PxETH";


export const assetList = [
    {
        title: "USDC",
        icon: <USDCIcon/>,
    },
    {
        title: "USDT",
        icon: <USDTIcon/>,
    },
    {
        title: "rUSD",
        icon: <RUSDIcon/>,
    },
    {
        title: "USD0++",
        icon: <USD0Icon/>,
    },
    {
        title: "WBTC",
        icon: <WBTCIcon/>,
    },
    {
        title: "WETH",
        icon: <WETHIcon/>,
    },
    {
        title: "wstETH",
        icon: <WSTETHIcon/>,
    },
    {
        title: "weETH",
        icon: <WeETHIcon/>,
    },
    // {
    //     title: "pxETH",
    //     icon: <PxETHIcon/>,
    // },
    {
        title: "cUSDO",
        icon: <CUSDOIcon/>,
    }
    // {
    //     title: "IvIUSD",
    //     icon: <IvIUSDIcon/>,
    // },
    // {
    //     title: "deUSD",
    //     icon: <DeUSDIcon/>,
    // },
];
